export default __webpack_public_path__ + "static/design-166f6de0cf89b8cd235a0390a696065e.jpg";